// Dictionary of human-readable counter parts for certain terms

const dictionary = {
  term: 'Hakutermi',
  year: 'Vuosi',
  year_start: 'Vuodesta',
  year_end: 'Vuoteen',
  ministerio: 'Valmisteleva ministeriö',
  talousarviot: 'Talousarviot',
  eduskunnan_kirjelma: 'Eduskunnan kirjelmä',
  asettaja: 'Asettaja',
  allekirjoittaja: 'Allekirjoittaja',
  hallitus_hk: 'Hallitus',
  asiasanat: 'Asiasanat',
  tunnus: 'Diaarinumero',
  type: 'Asiakirjatyyppi',
  valiokunta: 'Valiokunta',
  score: 'relevanssi',
  date_asc: 'vanhin ensin',
  date_desc: 'uusin ensin',
  alpha_asc: 'tunnus (nouseva)',
  alpha_desc: 'tunnus (laskeva)',
  tila: 'Tila',
  asettamis_paiva: 'Asettamispäivä',
  valmistumis_paiva: 'Valmistumispäivä',
  asian_tila: 'Asian tila',
  annettu_eduskunnalle: 'Annettu eduskunnalle',
  paatos: 'Päätös',
  saapunut: 'Saapunut',
  vahvistettu: 'Vahvistettu',
  voimaantulo: 'Voimaantulo',
  PAATTYNYT: 'Päättynyt',
  title: 'Otsikko',
  date: 'Päivämäärä',
  hallituksen_esitykset: 'Hallituksen esitys',
  valiokunta_asiakirjat: 'Valiokunta-asiakirja',
  lausuntokierros: 'Lausuntokierros',
  he_asiantuntijalausunnot: 'Asiantuntijalausunnot',
  lausuntokierros_asiakirjat: 'Lausuntokierros',
  poytakirja: 'Pöytäkirjat',
  LAUSUNTOPYYNTO: 'Lausuntopyyntö',
  KANNANOTTO: 'Kannanotto',
  PYYNTO: 'Pyyntö',
  PUHE: 'Puhe',
  KUTSU: 'Kutsu',
  ASETTAMISPAATOS: 'Asettamispäätös',
  SOPIMUS: 'Sopimus',
  RAPORTTI: 'Raportti',
  YHTEENVETO: 'Yhteenveto',
  MUISTIO: 'Muistio',
  LIITE: 'Liite',
  MIETINTO: 'Mietintö',
  LUPA: 'Lupa',
  KIRJE: 'Kirje',
  SUUNNITELMA: 'Suunnitelma',
  JULKAISU: 'Julkaisu',
  TIEDOTE: 'Tiedote',
  ESITYS: 'Esitys',
  PAATOS: 'Päätös',
  POYTAKIRJA: 'Pöytäkirja',
  LAUSUNTO: 'Lausunto',
  laatimispaiva: 'laatimispäivä',
  paiva: 'päivä',
  _index: 'Dokumenttityypit',
  laki_la: 'Lakialoite',
  laki_lausuntokierros: 'Valmisteluasiakirjat',
  laki_lausuntokierros_asiakirjat: 'Lausuntokierroksen asiakirjat',
  laki_he: 'Hallituksen esitykset',
  laki_vk: 'Valiokunta-asiakirjat',
  laki_puheenvuoro: 'Eduskuntakeskustelut',
  laki_ka: 'Kansalaisaloite',
  aloitus_paiva: 'Aloituspäivä',
};

const translate = (input) => dictionary[input] || input;

export default translate;
